import { Grid } from '@mui/material'
import { Box } from '@mui/system'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import { useContext, useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { RootStoresContext } from 'src'
import Footer from 'src/commponents/Footer'
import Header from 'src/commponents/Header'
import Loading from 'src/commponents/Loading'
import { BuildingWrapper, Wrapper } from 'src/commponents/Wrapper'
import { RouterPaths } from './RouterPaths'

interface IElementWrapper {
  isBackgroundImage: boolean
  isAuthScreen?: boolean
}

export const ElementWrapper = ({ isBackgroundImage, isAuthScreen = false }: IElementWrapper) => {
  return (
    <Wrapper isBackgroundImage={isBackgroundImage}>
      <BuildingWrapper
        container
        direction="column"
        justifyContent="space-between"
        wrap="nowrap"
        isBackgroundImage={isBackgroundImage}
      >
        <Grid item>
          <Box mb={5}>
            <Header />
          </Box>
        </Grid>

        <Grid item>
          <Outlet />
        </Grid>

        <Grid item>
          <Box mt={5}>
            <Footer isAuthScreen={isAuthScreen} />
          </Box>
        </Grid>
      </BuildingWrapper>
    </Wrapper>
  )
}

export const Auth = observer(() => {
  const location = useLocation()
  const RootStore = useContext(RootStoresContext)
  const {
    AuthStore: { isLoggedIn, isLoading, isTemporaryRegistration },
  } = RootStore

  if (isLoading) return <Loading />
  if (isTemporaryRegistration) return <Navigate replace to={RouterPaths.RegisterPassword} />
  if (!isLoggedIn) return <Navigate replace to={`${RouterPaths.Login}?ref=${location.pathname}`} />

  return <ElementWrapper isBackgroundImage isAuthScreen />
})

export const ListenLocation = () => {
  const location = useLocation()
  const RootStore = useContext(RootStoresContext)
  const { ConfigurationStore } = RootStore

  const [checkDate, setCheckDate] = useState(moment().subtract(2, 'hour'))
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (moment().diff(checkDate, 'hour') < 1) {
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    setCheckDate(moment())

    ConfigurationStore.get()
      .then(() => {
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
      })
  }, [location.pathname])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  if (isLoading) return <Loading />

  if (location.pathname !== RouterPaths.Maintenance && ConfigurationStore.configurations.isMaintenanceMode)
    return <Navigate replace to={RouterPaths.Maintenance} />

  return <Outlet />
}
